const CardStatusEnum = {
  UNREGISTERED: 1,
  REGISTERED: 2,
  COMPLETED: 3
}
export default CardStatusEnum



// WEBPACK FOOTER //
// ./src/enum/cardStatusEnum.js